<template>
  <modal
    class="modalPopupDialog"
    max-width="40%"
    :title="'Samenvatting ' + carConfigurationChangesResultText"
    @close="closeDialog"
  >
    <div class="modification-result">
      <change-order-result-row
        :has-changes="hasCarConfigurationChanges"
        :is-try-order-mode="isTryOrderMode"
        :title="i18n.t('/change-order/sections/configuration')"
        :is-success="carConfigurationChangesSubmittedSuccessful"
        :error-messages="formattedCarConfigurationErrorResult"
      >
        <br />
        <div v-if="!carConfigurationChangesSubmittedSuccessful">
          <div>
            <textarea
              v-if="hasProductCatalogueMessages"
              id="productCatalogueMessages"
              v-model="formattedProductCatalogueMessages"
              rows="10"
              readonly
              style="margin-top: 10px"
            ></textarea>
          </div>
        </div>
        <div v-if="showIfaMessages">
          <div class="ifa-errors-container">
            <label for="ifaErrors">
              {{ i18n.t('/change-order/results/show-ifa-error') }}
            </label>
            <span style="cursor: pointer" @click="toggleIfaErrorsVisibility">
              <i :class="`fas ${isIfaErrorsVisible ? 'fa-chevron-up' : 'fa-chevron-down'}`"></i>
            </span>
          </div>
          <textarea
            v-if="isIfaErrorsVisible"
            id="ifaErrors"
            v-model="formattedIfaErrors"
            rows="10"
            readonly
            style="margin-top: 10px"
          ></textarea>
        </div>
      </change-order-result-row>

      <!-- hasEstablishmentAndUnloadingLocationChanges -->
      <change-order-result-row
        :has-changes="hasEstablishmentAndUnloadingLocationChanges"
        :is-try-order-mode="isTryOrderMode"
        :title="i18n.t('/change-order/sections/dealer-and-location')"
        :is-success="establishmentAndUnloadingLocationChangesSubmittedSuccessful"
        :error-messages="formattedModifyEstablishmentErrorResults"
      />

      <!-- hasDeliveryDateChanges -->
      <change-order-result-row
        :has-changes="hasDeliveryDateChanges"
        :is-try-order-mode="isTryOrderMode"
        :title="i18n.t('/change-order/sections/delivery-dates')"
        :is-success="deliveryDateChangesSubmittedSuccessful"
        :error-messages="formattedDeliveryDateErrorResult"
      />

      <!-- hasCustomerChanges -->
      <change-order-result-row
        :has-changes="hasCustomerChanges"
        :is-try-order-mode="isTryOrderMode"
        :title="i18n.t('/change-order/sections/customer-data')"
        :is-success="customerChangesSubmittedSuccessful"
        :error-messages="formattedCustomerErrorResult"
      />

      <!-- hasReservationChanges -->
      <change-order-result-row
        :has-changes="hasReservationChanges"
        :is-try-order-mode="isTryOrderMode"
        :title="i18n.t('/change-order/sections/reservation')"
        :is-success="reservationChangesSubmittedSuccessful"
        :error-messages="formattedReservationChangesErrorResults"
      />

      <!-- hasLicensePlateChanges -->
      <change-order-result-row
        :has-changes="hasLicensePlateChanges"
        :title="i18n.t('/change-order/sections/license-plate')"
        :is-success="licensePlateChangesSubmittedSuccessful"
        :error-messages="formattedLicensePlateChangesErrorResults"
      />

      <!-- hasDeleteOrderChanges -->
      <change-order-result-row
        :has-changes="hasDeleteOrderChanges"
        :is-try-order-mode="isTryOrderMode"
        :title="i18n.t('/change-order/sections/delete-order')"
        :is-success="deleteOrderChangesSubmittedSuccessful"
        :error-messages="formattedDeleteOrderErrorResult"
      />

      <!-- hasGenericOrderChanges -->
      <change-order-result-row
        :has-changes="hasGenericOrderChanges"
        :is-try-order-mode="isTryOrderMode"
        :title="i18n.t('/change-order/sections/generic-error')"
        :is-success="false"
        :error-messages="formattedGenericOrderErrorResult"
      />

      <div v-if="dealerChangeHasError" class="dealer-support-contact-when-change-has-errors">
        <span>
          <p v-html="i18n.t('/change_order/error/dealer_support_message')"></p>
        </span>
      </div>

      <div class="close-button">
        <app-button data-qa="close-order-modal-button" @click="closeDialog"
          >{{ i18n.t('/Common/Close') }}
        </app-button>
      </div>
    </div>
  </modal>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import ChangeOrderResultRow from '@/components/changeOrder/presentational/organisms/changeOrderActions/ChangeOrderResultRow.vue'
import { mapGetters } from 'vuex'

export default {
  components: { Modal, AppButton, ChangeOrderResultRow },
  props: {
    isTryOrderMode: {
      type: Boolean,
      required: false,
      default: null,
    },
    showIfaMessages: {
      type: Boolean,
      required: false,
      default: true,
    },
    orderResult: {
      type: Object,
      default: function () {
        return {
          ModifyCarConfigurationResult: {
            MessageID: '',
            ErrorMessages: null,
            IfaStatus: '',
            IfaErrors: null,
            ProductCatalogueSeverity: '',
            ProductCatalogueMessages: null,
            Status: '',
          },
          ModifyEstablishmentResult: {
            ErrorMessages: null,
          },
          ModifyAdditionalInfoResult: {
            ErrorMessages: null,
          },
          ModifyUnloadingLocationResult: {
            ErrorMessages: null,
          },
          ModifyDeliveryDateResult: {
            ErrorMessages: null,
          },
          ModifyCustomerResult: {
            ErrorMessages: null,
          },
          RequestLicensePlateNumberResult: {
            ErrorMessages: null,
          },
          ModifyLicensePlateTypeResult: {
            ErrorMessages: null,
          },
          ModifyTaxResult: {
            ErrorMessages: null,
          },
          ModifyReservationResult: {
            ErrorMessages: null,
          },
          ModifyCommercialHoldResult: {
            ErrorMessages: null,
          },
          ModifyHoldShowRoomResult: {
            ErrorMessages: null,
          },
          ModifyHoldStockResult: {
            ErrorMessages: null,
          },
          ModifyTransportHoldResult: {
            ErrorMessages: null,
          },
          DeleteOrderResult: {
            ErrorMessages: null,
          },
          GenericResult: {
            ErrorMessages: null,
          },
        }
      },
    },
  },
  emits: ['close'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      isIfaErrorsVisible: false,
    }
  },
  computed: {
    ...mapGetters({
      dealerSettings: 'user/dealerSettings',
    }),
    formattedIfaErrors() {
      if (
        !this.orderResult.ModifyCarConfigurationResult.IfaErrors ||
        this.orderResult.ModifyCarConfigurationResult.IfaErrors.length === 0
      ) {
        return ''
      }
      return this.orderResult.ModifyCarConfigurationResult.IfaErrors.join('\n')
    },
    hasProductCatalogueMessages() {
      return !!(
        this.orderResult.ModifyCarConfigurationResult.ProductCatalogueMessages &&
        this.orderResult.ModifyCarConfigurationResult.ProductCatalogueMessages.length > 0
      )
    },
    formattedProductCatalogueMessages() {
      if (!this.hasProductCatalogueMessages) {
        return ''
      }
      return this.orderResult.ModifyCarConfigurationResult.ProductCatalogueMessages.join('\n')
    },
    carConfigurationChangesSubmittedSuccessful() {
      return this.orderResult.ModifyCarConfigurationResult?.Status === 'OK'
    },
    establishmentAndUnloadingLocationChangesSubmittedSuccessful() {
      return (
        this.orderResult.ModifyEstablishmentResult?.Status !== 'ERROR' &&
        this.orderResult.ModifyUnloadingLocationResult?.Status !== 'ERROR' &&
        this.orderResult.ModifyAdditionalInfoResult?.Status !== 'ERROR' &&
        this.orderResult.ModifyTransportHoldResult?.Status !== 'ERROR'
      )
    },
    hasCarConfigurationChanges() {
      return !!this.orderResult.ModifyCarConfigurationResult?.Status
    },
    hasEstablishmentAndUnloadingLocationChanges() {
      return !!(
        this.orderResult.ModifyEstablishmentResult?.Status ||
        this.orderResult.ModifyUnloadingLocationResult?.Status ||
        this.orderResult.ModifyAdditionalInfoResult?.Status ||
        this.orderResult.ModifyTransportHoldResult?.Status
      )
    },
    formattedModifyEstablishmentErrorResults() {
      const modifyEstablishmentErrorMessages =
        this.orderResult?.ModifyEstablishmentResult?.ErrorMessages
      const modifyUnloadingLocationErrorMessages =
        this.orderResult?.ModifyUnloadingLocationResult?.ErrorMessages
      const modifyAdditionalInfoErrorMessages =
        this.orderResult.ModifyAdditionalInfoResult?.ErrorMessages
      const modifyTransportHoldErrorMessages =
        this.orderResult.ModifyTransportHoldResult?.ErrorMessages

      return this.combineErrors(
        modifyEstablishmentErrorMessages,
        modifyUnloadingLocationErrorMessages,
        modifyAdditionalInfoErrorMessages,
        modifyTransportHoldErrorMessages
      )
    },
    hasDeliveryDateChanges() {
      return !!this.orderResult.ModifyDeliveryDateResult?.Status
    },
    hasCustomerChanges() {
      return !!this.orderResult.ModifyCustomerResult?.Status
    },
    hasReservationChanges() {
      return !!(
        this.orderResult.ModifyReservationResult ||
        this.orderResult.ModifyHoldShowRoomResult ||
        this.orderResult.ModifyHoldStockResult
      )
    },
    hasLicensePlateChanges() {
      return !!(
        this.orderResult.RequestLicensePlateNumberResult ||
        this.orderResult.ModifyLicensePlateTypeResult ||
        this.orderResult.ModifyCommercialHoldResult ||
        this.orderResult.ModifyTaxResult
      )
    },
    customerChangesSubmittedSuccessful() {
      return this.orderResult.ModifyCustomerResult?.Status === 'OK'
    },
    deliveryDateChangesSubmittedSuccessful() {
      return this.orderResult.ModifyDeliveryDateResult?.Status === 'OK'
    },
    reservationChangesSubmittedSuccessful() {
      return (
        this.orderResult.ModifyReservationResult?.Status !== 'ERROR' &&
        this.orderResult.ModifyHoldShowRoomResult?.Status !== 'ERROR' &&
        this.orderResult.ModifyHoldStockResult?.Status !== 'ERROR'
      )
    },
    formattedReservationChangesErrorResults() {
      let modifyReservationErrorMessages = this.orderResult.ModifyReservationResult?.ErrorMessages

      let requestShowroomHoldErrorMessages =
        this.orderResult.ModifyHoldShowRoomResult?.ErrorMessages

      let requestStockHoldErrorMessages = this.orderResult.ModifyHoldStockResult?.ErrorMessages

      return this.combineErrors(
        modifyReservationErrorMessages,
        requestShowroomHoldErrorMessages,
        requestStockHoldErrorMessages
      )
    },
    licensePlateChangesSubmittedSuccessful() {
      return (
        this.orderResult.RequestLicensePlateNumberResult?.Status !== 'ERROR' &&
        this.orderResult.ModifyLicensePlateTypeResult?.Status !== 'ERROR' &&
        this.orderResult.ModifyCommercialHoldResult?.Status !== 'ERROR' &&
        this.orderResult.ModifyTaxResult?.Status !== 'ERROR'
      )
    },
    formattedCarConfigurationErrorResult() {
      return this.orderResult.ModifyCarConfigurationResult?.ErrorMessages
    },
    formattedCustomerErrorResult() {
      return this.orderResult.ModifyCustomerResult?.ErrorMessages
    },
    formattedDeliveryDateErrorResult() {
      return this.orderResult.ModifyDeliveryDateResult?.ErrorMessages
    },
    formattedLicensePlateChangesErrorResults() {
      let modifyLicensePlateTypeErrorMessages =
        this.orderResult.ModifyLicensePlateTypeResult?.ErrorMessages
      let requestLicensePlateNumberErrorMessages =
        this.orderResult.RequestLicensePlateNumberResult?.ErrorMessages
      let modifyTaxResultErrorMessages = this.orderResult.ModifyTaxResult?.ErrorMessages
      let modifyCommercialHoldErrorMessages =
        this.orderResult.ModifyCommercialHoldResult?.ErrorMessages

      return this.combineErrors(
        modifyLicensePlateTypeErrorMessages,
        requestLicensePlateNumberErrorMessages,
        modifyTaxResultErrorMessages,
        modifyCommercialHoldErrorMessages
      )
    },
    hasDeleteOrderChanges() {
      return !!this.orderResult.DeleteOrderResult?.Status
    },
    deleteOrderChangesSubmittedSuccessful() {
      return this.orderResult.DeleteOrderResult?.Status === 'OK'
    },
    formattedDeleteOrderErrorResult() {
      return this.orderResult.DeleteOrderResult?.ErrorMessages
    },
    hasGenericOrderChanges() {
      return this.orderResult.GenericResult?.Status === 'ERROR'
    },
    formattedGenericOrderErrorResult() {
      return this.orderResult.GenericResult?.ErrorMessages
    },
    carConfigurationChangesResultText() {
      return this.isTryOrderMode ? 'proef wijziging' : 'wijziging'
    },
    dealerChangeHasError() {
      return (
        !this.dealerSettings.isImporter &&
        (this.orderResult.GenericResult?.Status === 'ERROR' ||
          this.orderResult.ModifyCarConfigurationResult?.Status === 'ERROR' ||
          this.orderResult.ModifyDeliveryDateResult?.Status === 'ERROR' ||
          this.orderResult.ModifyUnloadingLocationResult?.Status === 'ERROR')
      )
    },
  },
  methods: {
    combineErrors(...errorArrays) {
      let errorMessages = []

      for (const errors of errorArrays) {
        if (errors?.length > 0) {
          errorMessages.push(...errors)
        }
      }

      return errorMessages
    },
    closeDialog() {
      this.$emit('close')
    },
    toggleIfaErrorsVisibility() {
      this.isIfaErrorsVisible = !this.isIfaErrorsVisible
    },
  },
}
</script>

<style lang="scss" scoped>
.modalPopupDialog {
  z-index: 999;
}

.ifa-errors-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 5px;
}

.modification-result {
  margin-left: 30px;
}

.close-button {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.dealer-support-contact-when-change-has-errors {
  margin-left: 30px;
  margin-top: 20px;
}
</style>
